

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class DocumentExtractionOptions_ManagedObject

class DocumentExtractionOptions_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: groupLines
    set groupLines(value:boolean) {
        this.setValueForKey(value, 'groupLines');
    }
    get groupLines():boolean {
        return this.valueForKey('groupLines');
    }
    set groupLinesPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'groupLines');
    }
    get groupLinesPrimitiveValue():boolean {
        return this.primitiveValueForKey('groupLines');
    }

    // Property: pricesIncludeTax
    set pricesIncludeTax(value:boolean) {
        this.setValueForKey(value, 'pricesIncludeTax');
    }
    get pricesIncludeTax():boolean {
        return this.valueForKey('pricesIncludeTax');
    }
    set pricesIncludeTaxPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'pricesIncludeTax');
    }
    get pricesIncludeTaxPrimitiveValue():boolean {
        return this.primitiveValueForKey('pricesIncludeTax');
    }

    // Property: summaryOnly
    set summaryOnly(value:boolean) {
        this.setValueForKey(value, 'summaryOnly');
    }
    get summaryOnly():boolean {
        return this.valueForKey('summaryOnly');
    }
    set summaryOnlyPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'summaryOnly');
    }
    get summaryOnlyPrimitiveValue():boolean {
        return this.primitiveValueForKey('summaryOnly');
    }

    // Property: summaryTable
    set summaryTable(value:string) {
        this.setValueForKey(value, 'summaryTable');
    }
    get summaryTable():string {
        return this.valueForKey('summaryTable');
    }
    set summaryTablePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'summaryTable');
    }
    get summaryTablePrimitiveValue():string {
        return this.primitiveValueForKey('summaryTable');
    }
    // Relationship: groupLinesConcept
    set groupLinesConcept(value:ConceptItem) {
        this.setValueForKey(value, 'groupLinesConcept');
    }
    get groupLinesConcept():ConceptItem {
        return this.valueForKey('groupLinesConcept') as ConceptItem;
    }
    // Relationship: legalEntity
    set legalEntity(value:LegalEntity) {
        this.setValueForKey(value, 'legalEntity');
    }
    get legalEntity():LegalEntity {
        return this.valueForKey('legalEntity') as LegalEntity;
    }
}
